import { Spinner } from "components/individual/Spinner/Spinner";
import LoadingText from "components/individual/TextLoading";
import useItems from "customHooks/useItems";
import React, { createContext } from "react";
// import Select from "react-select";
import Select from 'react-select/creatable';


/**
 * Context of the component
 * @type {React.Context<import("./types").CatalogueContextI>}
 */
export const ContextCatalogue = createContext(undefined);
const { Provider } = ContextCatalogue;

/**
 * Render select combo of the catalogue
 * @param {object} props - Props
 * @param {(object:import("types/typedef/catalogue").CalculatedItemI)=>void} [props.onSelect=()=>{}] - Information of the item selected (existing or created)
 * @param {"cotizacion"|"pedido"|"contrato"|"odc"} props.typeDocument - Type of document that's being created
 * @param {(object:import("types/typedef/catalogue").CalculatedItemI)=>void} [props.onChange=()=>{}]
 * @param {number|null} [props.defaultValue=null] - Default value for the item selected on the catalogue
 * @returns {JSX.Element} Combo catalogue
 */
export default function CatalogueV2({
  onSelect = () => {},
  onChange = () => {},
  typeDocument,
  defaultValue = null,
}) {
  const {
    catalogue,
    isLoading,
    idBtnOpenNewItemCatalogue,
    handleNewItemV2,
    setItem,
    item,
  } = useItems(defaultValue);

  /**
   *
   * @param {import("types/typedef/catalogue").CatalogueItemI|{
   *  label:string,
   *  value:string,
   *  __isNew__?:true
   * }} item
   */
  const handleOnChange = (item) => {
    if (!item) {
      setItem(null);
      return;
    }

    const isNewItem = Object.keys(item).includes("__isNew__") ? true : false;

    let currentItem;
    if (!item) {
      currentItem = {
        value: null,
        isNewItem,
      };
    } else {
      currentItem = {
        ...item,
        isNewItem,
      };
    }
    if (isNewItem) {
      handleNewItemV2(currentItem);
    } else {
      setItem(currentItem);
    }
    onSelect(currentItem);
  };

  return (
    <Provider
      value={{
        catalogue,
        isLoading,
        idBtnOpenNewItemCatalogue,
        item,
        typeDocument,
      }}
    >
      {isLoading ? (
        <Spinner hidden={false} text={<LoadingText>Cargando</LoadingText>} />
      ) : (
        <Select
          isClearable={false}
          className="saiko-select"
          classNamePrefix="saiko-select"
          options={catalogue}
          placeholder="Selecciona"
          onChange={(value) => {
            handleOnChange(value);
            onChange(value);
          }}
          value={item}
        />
      )}
    </Provider>
  );
}
